


import { useState } from "react";
import { Button, Input, Label } from "./Shared";
import getUSPSSortation from "./util/Sortation";

const Test = () => {
   

  const input = {
mailClass: "STD",
  productWeight: 2,
  productHeight: 5,
  productLength: 7,
  productThickness: 0.1,
  imBarcode: true,
  isUniformThickness: true,
  isFlexible: true,
  presortOnly: false
};
 const [form, setForm]= useState(input)
 const [result, setResult]= useState({})

const sub = (e) => {
    e.preventDefault()
setResult(getUSPSSortation(form));
}

console.log(result); // Example output: { sortation: "FCM AUTO LETTERS"



return (
    <>
    <form onSubmit={sub}>
    <div className="px-25 py-25">
    <div className="flex gap-10 ">
<div className="flex-1">Mail Class<br /><Input value={form?.mailClass} onChange={e => setForm({...form,mailClass: e.target.value})}  type="text" /></div>
<div className="flex-1">Weight<br /><Input value={form?.productWeight} onChange={e => setForm({...form,productWeight: e.target.value})}  type="text" /></div>
<div className="flex-1">Height<br /><Input value={form?.productHeight} onChange={e => setForm({...form,productHeight: e.target.value})}  type="text" /></div>
<div className="flex-1">Length<br /><Input value={form?.productLength} onChange={e => setForm({...form,productLength: e.target.value})}  type="text" /></div>
<div className="flex-1">Thickness<br /><Input value={form?.productThickness} onChange={e => setForm({...form,productThickness: e.target.value})}  type="text" /></div>

    </div>

<div className="flex gap-10 items-center py-10">
  <div className="flex flex-1 items-center gap-2">
    <input type="checkbox" className="h-4 w-4" checked={form?.imBarcode} onChange={e => setForm({...form,imBarcode: e.target.checked})}/>
    <label className="text-sm">IM Barcode</label>
  </div>
  <div className="flex flex-1 items-center gap-2">
    <label className="text-sm">Uniform Thickness</label>
    <input type="checkbox" className="h-4 w-4"  checked={form?.isUniformThickness} onChange={e => setForm({...form,isUniformThickness: e.target.checked})}/>
  </div>
  <div className="flex flex-1 items-center gap-2">
    <label className="text-sm">Flexible</label>
    <input type="checkbox" className="h-4 w-4"  checked={form?.isFlexible} onChange={e => setForm({...form,isFlexible: e.target.checked})}/>
  </div>
  <div className="flex flex-1 items-center gap-2">
    <label className="text-sm">Presort Only</label>
    <input type="checkbox" className="h-4 w-4"  checked={form?.presortOnly} onChange={e => setForm({...form,presortOnly: e.target.checked})}/>
  </div>
</div>
    </div>
 <div className="px-25 pt-10">
    <Button>Tess Za Ahnzer</Button>
    </div>

    <div className="px-25 ">{result.selectedMailClass || result.error }</div>
    <div className="px-25 ">{result.selectedMachinability || result.error }</div>
      <div className="px-25 ">{result.selectedCategory || result.error }</div>
    <br />
  
        <div className="px-25 ">{result.sortation || result.error }</div>
    </form>



</>
)
}
export default Test




